export default __webpack_public_path__ + "a4b141575c3e7e0968b6960facd70cf5.svg";